import Vue from "vue";

Vue.filter("priceToUsd", (value) => {
  const newValue = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);
  return `$ ${newValue.split("$").join().replace(/,/g, "")}`;
});
